module.exports = __webpack_public_path__ + "img/32.0a758346.png";